import QuantityCell from "./QuantityCell";
import TotalPriceCell from "./TotalPriceCell";
import CustomTag from "./CustomTag.jsx";

const columnsConfig = [
  {
    field: "id",
    headerName: "Референция",
    flex: 0.5,
    type: "string",
  },

  {
    field: "barcode",
    headerName: "Баркод",
    flex: 0.8,
    type: "string",
    valueGetter: (value, row) => (row.barcode ? row.barcode : ""),
  },

  {
    field: "name",
    headerName: "Име",
    flex: 1.5,
    type: "string",
  },

  {
    field: "list_price",
    headerName: "Цена",
    flex: 1.2,
    minWidth: 195,
    cellClassName: "rightAlign",
    type: "number",
    renderCell: (params) => (
      <div style={{ lineHeight: 1.4 }}>
        <div>{Number(params.row.list_price).toFixed(2)} EUR</div>
        <div>{(params.row.list_price * 1.95583).toFixed(2)} лв.</div>
      </div>
    ),
  },

  {
    field: "quantity",
    headerName: "Количество",
    width: 90,
    type: "number",
    align: "center",
    cellClassName: "rightAlign",
    renderCell: (params) => <QuantityCell params={params} />,
  },

  {
    field: "total_price",
    headerName: "Общо",
    flex: 1.2,
    minWidth: 195,
    type: "number",
    cellClassName: "rightAlign",
    renderCell: (params) => <TotalPriceCell params={params} />,
  },

  {
    id: "tag_ids",
    field: "tag_ids",
    headerName: "Тагове",
    flex: 3,
    renderCell: (params) => <CustomTag params={params}  />,
    valueGetter: (value, row) => row.tag_ids?.map((tag) => tag.id).join(", "),
  },
];

export default columnsConfig;
